import React from 'react';
import {useFormikContext} from 'formik';
import MultimediaLinks from './multimedia-links';
import DatePicker from 'src/components/date-picker';
import Label from 'shared/components/label';
import FormikTextArea from 'src/components/formik-text-area';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import FormikDropdown from 'src/components/formik-dropdown';
import {MULTIMEDIA_CATEGORIES} from 'shared/utils';
import {Multimedia} from './multimedia-form-wrapper';

const categories = MULTIMEDIA_CATEGORIES.map((type) => ({value: type, text: type}));

export default function MultimediaFormInputs() {
  const formik = useFormikContext<Multimedia>();

  return (
    <>
      <p>
        Link samples of your artwork, including photos, videos, presentations, websites, documents
        and more. Show your best work to Raise Me colleges to earn up to $500 per project added.
      </p>
      <p>
        Check out some supported content providers.&nbsp;
        <a
          href="https://help.raise.me/hc/en-us/articles/115003013093"
          rel="noopener noreferrer"
          target="_blank"
        >
          Learn More
        </a>
      </p>

      <div className="multimedia-providers" />

      <legend className="shared-required-legend"></legend>

      <div className="portfolio-sections side-by-side">
        <Label required>
          Category
          <FormikDropdown name="category" options={categories} required />
        </Label>
        <DatePicker
          month={formik.values.month}
          monthOnChange={(value) => formik.setFieldValue('month', value)}
          monthError={formik.errors.month}
          year={formik.values.year}
          yearOnChange={(value) => formik.setFieldValue('year', value)}
          yearError={formik.errors.year}
          required
        />
      </div>

      <Label required>
        Title
        <FormikTextInput name="title" required placeholder="Enter a title for your project" />
      </Label>

      <Label required>
        Description
        <FormikTextArea
          name="description"
          placeholder="Describe your artwork (e.g. medium used, year it was created, anything else you’d like to say about it)"
          required
        />
      </Label>

      <MultimediaLinks />
    </>
  );
}
